/**
 * 2007-2017 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Open Software License (OSL 3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * http://opensource.org/licenses/osl-3.0.php
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2017 PrestaShop SA
 * @license   http://opensource.org/licenses/osl-3.0.php Open Software License (OSL 3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import 'expose?Tether!tether';
import 'bootstrap/dist/js/bootstrap.min';
import 'flexibility';
import 'bootstrap-touchspin';
import 'slick-carousel';
import '../css/theme';
import './responsive';
import './checkout';
import './customer';
import './listing';
import './product';
import './cart';
import DropDown from './components/drop-down';
import Form from './components/form';
import './components/product-miniature';
import ProductSelect from './components/product-select';
import TopMenu from './components/top-menu';
import prestashop from 'prestashop';
import EventEmitter from 'events';
import './lib/bootstrap-filestyle.min';
import './lib/jquery.scrollbox.min';
import './lib/jquery.uitotop.min';
import './components/block-cart';
import './components/tmmegamenu';
import './components/homeslider';
import './components/tmlookbook';
import './components/tmproductzoomer';
// "inherit" EventEmitter
for (var i in EventEmitter.prototype) {
  prestashop[i] = EventEmitter.prototype[i];
}
$(document).ready(() => {
  let dropDownEl = $('.js-dropdown');
  const form = new Form();
  let topMenuEl = $('.js-top-menu ul[data-depth="0"]');
  let dropDown = new DropDown(dropDownEl);
  let topMenu = new TopMenu(topMenuEl);
  let productSelect = new ProductSelect();
  dropDown.init();
  form.init();
  topMenu.init();
  productSelect.init();
  let stickUp = $(".stick-up");
  if (stickUp.length && $('body').width() > 1199) {
    stickUp.wrap('<div class="stickUpTop"><div class="stickUpHolder">');
    $('.stickUpTop').tmStickUp();
  }
  subcategorySlider();
  productsCarousel();
  toTop();
  $('#cms').find('#testimonials').slick({
    infinite: false,
    slidesToShow: 1,
    arrows: false,
    dots: true,
    slidesToScroll: 1
  });
});
/* Stik Up menu script */
(function($) {
  $.fn.tmStickUp = function(options) {
    var getOptions = {
      correctionSelector: $('.correctionSelector')
    };
    $.extend(getOptions, options);
    var
      _this = $(this)
      , _window = $(window)
      , _document = $(document)
      , thisOffsetTop = 0
      , thisOuterHeight = 0
      , thisMarginTop = 0
      , thisPaddingTop = 0
      , documentScroll = 0
      , pseudoBlock
      , lastScrollValue = 0
      , scrollDir = ''
      , tmpScrolled
    ;
    init();
    function init() {
      thisOffsetTop = parseInt(_this.offset().top);
      thisMarginTop = parseInt(_this.css('margin-top'));
      thisOuterHeight = parseInt(_this.outerHeight(true));
      $('<div class="pseudoStickyBlock"></div>').insertAfter(_this);
      pseudoBlock = $('.pseudoStickyBlock');
      pseudoBlock.css({'position': 'relative', 'display': 'block'});
      addEventsFunction();
    }//end init
    function addEventsFunction() {
      var isS = false;
      var stuck;
      _document.on('scroll', function() {
        tmpScrolled = $(this).scrollTop();
        if (tmpScrolled > lastScrollValue) {
          scrollDir = 'down';
        } else {
          scrollDir = 'up';
        }
        lastScrollValue = tmpScrolled;
        let correctionValue = getOptions.correctionSelector.outerHeight(true);
        documentScroll = parseInt(_window.scrollTop());
        stuck = thisOffsetTop - correctionValue + 250 < documentScroll;
        if (stuck && !isS) {
          _this.addClass('isStuck');
          _this.css({position: 'fixed', top: correctionValue});
          pseudoBlock.css({'height': thisOuterHeight});
          isS = true;
        } else if (!stuck && isS) {
          _this.css({top: -70});
          setTimeout(function() {
            _this.removeClass('isStuck');
            _this.css({position: 'relative', top: 0});
            pseudoBlock.css({'height': 0});
          }, 100);
          isS = false;
        }
      }).trigger('scroll');
    }
  };//end tmStickUp function
})(jQuery);
function subcategorySlider() {
  let subcategory = $('.subcategories ul');
  if (subcategory.length && !!$.prototype.bxSlider) {
    subcategory.bxSlider({
      slideWidth: 230,
      pager: false,
      nextText: '',
      prevText: '',
      minSlides: 3,
      maxSlides: 3,
      slideMargin: 20,
      moveSlides: 1,
      infiniteLoop: false,
      hideControlOnEnd: true,
      responsive: true,
      useCSS: false,
      autoHover: false,
      auto: false,
      speed: 500,
      pause: 3000,
      controls: true,
      autoControls: false
    });
  }
}
function productsCarousel() {
  let products = $('.products.carousel');
  products.each(function() {
    let slick = $(this),
      autoplay = $(this).data('autoplay');
    slick.slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: autoplay,
      responsive: [
        {
          breakpoint: 1250,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    });
  });
}
function toTop() {
  if (!prestashop.responsive.mobile) {
    $('html').UItoTop({
      easingType: 'easeOutQuart',
      containerClass: 'ui-to-top fl-outicons-chevron1'
    });
  }
}


// WEBPACK FOOTER //
// ./js/theme.js